import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Kembali',
      changePassword: 'Ubah Sandi',
      copiedVaultId: 'Disalin!',
      copyVaultID: 'Salin ID Vault',
      create: 'Buat',
      next: 'Berikutnya',
      notSure: 'Saya tidak yakin',
      signUp: 'Daftar',
      submit: 'Kirim',
      updatePassword: 'Perbarui kata sandi',
    },
    Errors: {
      createReportFailed: 'Gagal membuat laporan.',
    },
    ReportStatus: {
      CLOSED: 'Ditutup',
      INVESTIGATING: 'Sedang Menyelidiki',
      NEW: 'Diajukan',
      READ: 'Dibaca',
    },
    general: {
      navbar: {
        caseSettings: 'Pengaturan Kasus',
        changePassword: 'Ubah sandi',
        logOut: 'Keluar',
        notifications: 'Notifikasi',
        notificationsDrawer: {
          appFileScanFailed: 'Sebuah file gagal dalam pemeriksaan keamanan',
          appReportMatch: 'Record GoTogether Anda telah cocok',
          appReportReassigned: 'Seorang manajer kasus baru telah ditugaskan',
          case: 'Kasus',
          caseAssigned: 'Kasus ditugaskan kepada Anda',
          caseImporterJobCompleted: {
            PartialSuccess:
              'Impor kasus Anda selesai dengan beberapa kesalahan',
            failure: 'Impor kasus Anda gagal',
            success: 'Impor kasus Anda berhasil dilakukan',
          },
          caseLinked: 'Kasus terkait',
          caseTeamInvite: 'Ditambahkan ke kasus',
          caseUnlinked: 'Kasus tidak terhubung',
          dataSanitisation: 'Detail laporan diperbarui',
          emptyDescription: 'Periksa kembali nanti untuk notifikasi baru',
          emptyTitle: 'Anda sudah mengejar ketinggalan',
          importId: 'ID Impor:',
          learnMore: 'Pelajari lebih lanjut',
          markAllAsRead: 'Tandai semua sebagai sudah dibaca',
          newMessage: 'Pesan baru',
          newReport: 'Laporan baru diterima',
          permissionRemoved: 'Dihapus dari kasus',
          postSSubmissionFile: 'File bukti telah ditambahkan',
          report: 'Laporan',
          reportAssigned: 'Laporan yang ditugaskan kepada Anda',
          reportStatusChange: 'Status laporan berubah',
          reporterAnonymised: 'Detail Anda telah dianonimkan',
          reporterReportSubmitted: {
            subtitle:
              'Kami merekomendasikan untuk menyimpan salinan dari laporan Anda',
            title: 'Laporan telah diserahkan',
          },
          mitigationPlanReminder: 'Persetujuan rencana mitigasi diperlukan',
          staleCase: 'Kasus yang tidak ditindaklanjuti',
        },
        privacyStatement: 'Pernyataan privasi',
        reporter: {
          myReports: 'Laporan saya',
        },
        settings: 'Pengaturan',
        technicalSupport: 'Dukungan teknis',
        title: 'Akun',
      },
      time: {
        day: 'Hari',
        days: 'Hari-hari',
        hour: 'Jam',
        hours: 'Jam',
        minute: 'Menit',
        minutes: 'Menit',
        second: 'Kedua',
        seconds: 'Detik',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Anonim',
        autoTranslate: 'Auto-translate secara default dimatikan.',
        backToMessages: 'Kembali ke pesan',
        caseSettings: 'Pengaturan kasus.',
        changeInProfile:
          'Jika Anda ingin mengubah pengaturan ini, Anda dapat melakukannya di profil Anda',
        deletedByMessage: 'Dihapus oleh {{author}}',
        deletedMessageLabel: 'Pesan ini telah dihapus',
        description:
          'Ketika terjemahan otomatis diaktifkan, semua pesan laporan akan\n          diterjemahkan secara otomatis menggunakan AI berdasarkan bahasa default\n          yang dipilih di browser Anda.',
        descriptionSecondHalf:
          'Versi asli dari semua pesan selalu dipertahankan dan dapat ditemukan di obrolan.',
        messagePlaceholder: 'Mulai mengetik...',
        messageSettings: 'Pengaturan pesan.',
        originalMessages: 'Asli',
        showMoreBanner: 'Pelajari lebih lanjut tentang terjemahan otomatis',
        titlev2: 'Baca semua pesan dalam bahasa yang Anda sukai.',
        translatedMessageLabel: 'Pesan Terjemahan',
        translatedMessages: 'Diterjemahkan',
        understood: 'Mengerti',
      },
      Country: {
        description: 'Di negara mana Anda berkedudukan?',
        header: 'Di negara mana Anda berkedudukan?',
        noOptions: 'Tidak ada negara yang ditemukan',
        other: 'Lainnya',
        placeholder: 'Cari negara...',
      },
      CreatePublicReport: {
        createReport: 'Buat laporan baru',
        helpPage: 'Pergi ke halaman bantuan kami',
        loginToOpr: 'Masuk untuk Melacak Laporan',
        or: 'atau',
        passwordPlaceholder: 'Masukkan Sandi',
        phoneNumberLoginFailed: 'Login gagal, nomor telepon/pin salah',
        phoneNumberPlaceholder: 'Masukkan Nomor Telepon Anda',
        phoneNumberTooltip:
          'Masukkan nomor telepon yang Anda gunakan untuk menghubungi VaultTalk',
        pinPlaceholder: 'Masukkan Pin',
        reportIntroductionParagraph1:
          'Ketika melaporkan sebuah insiden, Anda akan ditanyakan beberapa pertanyaan untuk mendukung Anda dalam mendokumentasikan pengalaman Anda.',
        reportIntroductionParagraph2:
          'Sebelum Anda mengirim, Anda memiliki opsi untuk tetap anonim untuk melindungi privasi Anda.',
        reportIntroductionParagraph3:
          'Setelah Anda mengirimkan, Anda dapat masuk kapan saja untuk melihat perkembangan laporan Anda & berbicara dengan manajer kasus.',
        reportIssue: 'Laporkan masalah',
        usernameLoginFailed:
          'Gagal masuk, nama pengguna/kata sandi tidak benar',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired:
              'Hubungan dengan perusahaan diperlukan',
            reportedCategoryRequired: 'Kategori yang dilaporkan diperlukan',
          },
        },
        vaultId: 'Vault ID',
        vaultIdPlaceholder: 'Masukkan Email atau ID Vault Anda',
        vaultIdTooltip:
          'Untuk laporan anonim, ID Vault adalah alfanumerik. Jika laporannya tidak anonim, ID Vault adalah alamat email Anda.',
        vaultTalk: 'VaultTalk',
        yourPassword: 'Kata Sandi Anda',
        yourPhoneNumber: 'Nomor Telepon Anda',
        yourPin: 'Pin 6 Digit Anda',
        yourVaultId: 'ID Vault Anda',
      },
      CustomHeader: {
        companyLogo: 'Logo Perusahaan',
        openReporting: 'Buka Pelaporan',
        userSettings: 'Pengaturan Pengguna',
      },
      Date: {
        approximateDescription:
          'Apakah Anda ingat tanggal kira-kira terjadinya peristiwa tersebut?',
        approximatePlaceholder:
          'Contoh: 6 bulan yang lalu / tahun lalu / November lalu',
        cancel: 'batalkan',
        clear: 'hapus',
        description: 'Apakah Anda ingat tanggal terjadinya peristiwa tersebut?',
        header: 'Pada hari apa peristiwa itu terjadi?',
        ok: 'ok',
        placeholder: 'Contoh: 21 Juni 2020',
      },
      Description: {
        whatHappened: 'Apa yang terjadi?',
        whatHappenedPlaceholder: 'Gunakan kata-kata Anda sendiri...',
        whatHappenedText:
          'Dengan kata-kata Anda sendiri jelaskan apa yang terjadi',
      },
      Details: {
        disclaimer:
          'Rincian ini akan diungkapkan bersama laporan Anda. Jika Anda ingin tetap anonim, pastikan mereka tidak berisi informasi identifikasi.',
        emailPlaceholder: 'Email (opsional)',
        fullNamePlaceholder: 'Nama Lengkap (opsional)',
        header: 'Detail Anda',
        nonAnonSubtitle:
          'Harap berikan nama Anda atau alamat email. Jika Anda ingin menerima pemberitahuan tentang laporan ini, tambahkan alamat email yang sesuai di bawah ini.',
        nonOptionalEmailPlaceholder: 'Email',
        nonOptionalFullNamePlaceholder: 'Nama Lengkap',
        subtitle:
          'Jika Anda ingin menerima notifikasi tentang laporan ini, tambahkan alamat email yang sesuai di bawah ini.',
      },
      Emotion: {
        description:
          'Bagaimana perasaan Anda sebagai akibatnya? Apa dampaknya?',
        header: 'Apa dampaknya?',
        placeholder: 'Mulai mengetik...',
      },
      Evidence: {
        addedHeading: 'Ditambahkan',
        deletedMessage: 'dihapus',
        deletedStatus: 'Dihapus',
        failedToOpenFileMessage: 'Gagal membuka file. Silakan coba lagi',
        fileStatuses: {
          infectedUpload: 'Ditandai oleh pemeriksaan keamanan',
          passedUpload: 'Lulus pemeriksaan keamanan',
          pendingUpload: 'Pemeriksaan keamanan sedang berlangsung',
          readyForDownload: 'Siap untuk diunduh',
        },
        mobileErrorMessage: 'Berkas yang ditandai: pesan manajer kasus Anda',
        nameHeading: 'Nama',
        statusHeading: 'Status',
        tableTitle: 'Bukti',
        webErrorMessage:
          'Berkas yang ditandai: Jika berkas Anda telah ditandai, silakan kirim pesan ke manajer kasus',
      },
      FileUpload: {
        addFiles: 'Tambahkan file',
        addMoreFiles: 'Tambahkan lebih banyak file',
        confirm: 'Konfirmasi',
        description:
          'Menambahkan file sebagai bukti dapat mendukung efisiensi penyelesaian oleh manajer kasus Anda. Harap pertimbangkan konten file (termasuk metadata file) jika Anda ingin tetap anonim, dan hormati hak individu lain serta hukum yang berlaku.',
        dragDrop: 'Jatuhkan file di sini atau',
        errorMessage:
          'File(s) gagal karena kesalahan jaringan. Klik di bawah ini untuk mengirim pesan kepada manajer kasus Anda untuk bantuan.',
        fileLimit: 'Batas ukuran setiap file: 100MB',
        fileUploadLimitText: 'Anda hanya dapat mengunggah 10 file',
        header: 'Tambahkan bukti',
        helpArticle: 'artikel bantuan',
        highlighted: 'telusuri berkas',
        information: 'Jenis file yang didukung',
        moreInformation:
          'Untuk info lebih lanjut, silakan lihat ini <a>artikel bantuan</a>',
        postSubmissionErrorMessage:
          "Kami tidak dapat mengunggah file Anda karena kesalahan sistem. Silakan pilih 'konfirmasi' lagi.",
        tooltipAudio: 'Audio:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Dokumen:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Gambar:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Teks:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Video:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'File terlalu besar',
          invalidFileType: 'Jenis file yang tidak didukung: {{extension}}',
          systemError: 'Kesalahan sistem',
          tooManyFiles: 'Jumlah maksimum file adalah {{maxFiles}}',
        },
        uploadFiles: 'Unggah file',
      },
      Loading: {
        loading:
          'Harap tunggu sementara kami mengajukan laporan Anda kepada manajer kasus...',
        postSubmissionLoading:
          'Harap tunggu sementara kami mengirimkan berkas Anda...',
      },
      Location: {
        description: 'Di mana peristiwa itu terjadi?',
        header: 'Di mana peristiwa itu terjadi?',
        placeholder: 'Contoh: Di kantor',
      },
      MessageListBox: {
        messageCaseManager: 'Kirim pesan kepada manajer kasus',
        report: 'Laporan {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Terjemahan dinonaktifkan',
        enableTranslationLabelEnabled: 'Terjemahan diaktifkan',
        enableTranslationsDescription:
          'Aktifkan terjemahan otomatis dan baca semua pesan laporan dalam bahasa yang Anda preferensikan. Bahasa terjemahan didasarkan pada bahasa yang dipilih di perangkat Anda.',
        enableTranslationsHeader:
          'Aktifkan terjemahan otomatis untuk pesan laporan',
        enableTranslationsSubDescriptionv2:
          'Anda dapat beralih antara bahasa terjemahan dan bahasa asli di setiap obrolan.',
        updateTranslationFailed: 'Pembaruan terjemahan gagal',
        updateTranslationSuccess:
          'Pengaturan terjemahan diperbarui dengan sukses',
      },
      Password: {
        changePasswordHeader: 'Ubah Sandi',
        createNewPassword: 'Harap buat sandi baru',
        createPasswordHeader: 'Sandi Anda',
        currentPasswordPlaceholder: 'Masukkan sandi saat ini',
        description:
          'Sandi yang valid harus memiliki panjang minimal 9 karakter dan mencakup satu huruf besar dan satu angka',
        enterCurrentPassword: 'Silakan masukkan sandi Anda yang berlaku',
        forgottenPasswordInstructions:
          'Masukkan ID Vault alfanumerik Anda (bukan alamat email Anda) dan alamat email untuk mereset kata sandi Anda.',
        newDescription:
          'Buatlah kata sandi yang kuat untuk menjaga keamanan akun Anda. Mulai mengetik untuk melihat panduan di bawah ini.',
        passwordPlaceholder: 'Buat sandi',
        passwordResetRequestedDescription:
          'Jika ID Vault Anda ada di sistem kami, Anda akan menerima email dengan instruksi untuk mereset kata sandi Anda.',
        passwordResetRequestedHeader: 'Link reset kata sandi diminta',
        reenterPlaceholder: 'Masukkan sandi sekali lagi',
        subtitle:
          'Buat sandi untuk mengajukan laporan ini dan mengaksesnya nanti',
        yourVaultId: 'ID Vault Anda',
        yourVaultIdPlaceholder: 'Masukkan ID Vault Anda (mis. {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Apakah Anda melaporkan satu orang tertentu atau beberapa orang? Bisakah Anda menyebutkan nama atau menggambarkan orang tersebut?',
        header: 'Orang yang terlibat',
        placeholder:
          'Mulai mengetik dan gunakan koma untuk menambahkan beberapa nama atau deskripsi',
      },
      PoweredByVault: 'Didukung oleh {{company}}',
      PrivacyStatement: 'Pernyataan Privasi Produk',
      PublicMessageList: {
        myMessages: 'Pesan saya',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'Bukti ditambahkan ke laporan yang ada',
        backToReportId: 'Kembali ke laporan ID: {{reportId}}',
        description:
          'Menambahkan berkas sebagai bukti dapat membantu mendukung efisiensi penyelesaian oleh manajer kasus Anda. Harap pertimbangkan konten file (termasuk metadata file) jika Anda ingin tetap anonim, dan hargai hak individu lain dan hukum yang berlaku. Untuk informasi lebih lanjut, silakan lihat ini <a>artikel bantuan</a>',
        header: 'Tambahkan bukti tambahan ke dalam laporan',
        vaultTalkOpenCaseHeader: 'Tambahkan bukti ke laporan Anda',
      },
      PublicReport: {
        anonymous: 'Anonim',
        backToReports: 'Kembali ke laporan',
        skipped: 'Dilewati',
      },
      PublicReportCard: {
        addEvidence: 'Tambahkan bukti tambahan',
        messageCaseManager: 'Kirim pesan kepada manajer kasus',
        reportId: 'ID Laporan:',
        submitted: 'Diajukan',
        vaultTalkClosedCaseCTA: 'Lihat Bukti',
        vaultTalkOpenCaseCTA: 'Tambahkan Bukti',
        viewAdditionalEvidence: 'Lihat bukti tambahan',
        viewReport: 'Lihat Laporan',
      },
      PublicReportsList: {
        reportingSystem: 'Sistem Pelaporan',
      },
      Question: {
        placeholder: 'Mulai mengetik...',
        question: 'Berikan rincian',
        questionText:
          'Silakan bagikan kekhawatiran, pembaruan, atau pertanyaan Anda kepada kami.',
      },
      Relationship: {
        header: 'Hubungan Anda dengan organisasi',
        tellUsAbout:
          'Harap beri tahu kami tentang hubungan Anda dengan organisasi.',
      },
      ResponsiveNavMenu: {
        messages: 'Pesan saya',
        reports: 'Laporan saya',
      },
      Site: {
        description: 'Di lokasi mana Anda berkedudukan?',
        header: 'Di lokasi mana Anda berkedudukan?',
        noOptions: 'Tidak ada lokasi yang ditemukan',
        other: 'Lainnya',
        placeholder: 'Cari lokasi...',
      },
      SpamPuzzle: {
        dialog: 'Untuk melanjutkan, harap pecahkan teka-teki ini',
      },
      SubmissionTypes: {
        reportIssue: 'Pilih kategori',
        whatType: 'Pilih kategori yang paling menggambarkan laporan Anda',
      },
      SubmitSuccess: {
        category: '<bold>Kategori:</bold> {{kategori}}',
        country: '<bold>Negara:</bold> {{country}}',
        dateSubmitted: '<bold>Tanggal pengajuan:</bold> {{date}}',
        recordYourVaultID: 'Ingatlah informasi ini untuk masuk',
        successInformation: 'Informasi lebih lanjut',
        successMessage:
          'Laporan Anda telah diajukan dan siap untuk ditinjau. Setiap file yang dilampirkan yang membutuhkan perhatian akan ditandai saat login. Login di bawah ini untuk melihat pembaruan laporan dan mengirim pesan kepada manajer kasus Anda.',
        successSanitationMessage:
          'Simpan salinan untuk catatan Anda, dan jaga ID Vault Anda agar tetap aman — Anda akan membutuhkannya untuk mengakses pembaruan dan mengirim pesan ke manajer kasus Anda.',
        successSanitationTagline:
          'Laporan Anda telah dikirim dan disimpan dengan aman.',
        successThankYou: 'Terima kasih atas laporan Anda!',
        viewReport: 'Lihat laporan',
      },
      Time: {
        approximateDescription:
          'Apakah Anda ingat tanggal kira-kira terjadinya peristiwa tersebut?',
        approximatePlaceholder: 'Contoh: pagi hari, sore hari',
        description: 'Apakah Anda ingat waktu terjadinya peristiwa tersebut?',
        header: 'Pada jam berapa peristiwa itu terjadi?',
        invalidTime: 'Format waktu harus berupa JJ:MM',
      },
      UserSettingsDialog: {
        changePassword: 'Ubah Sandi',
        closeDialog: 'Tutup Dialog',
        logout: 'Log out',
        messageSettings: 'Pengaturan Pesan',
        userSettings: 'Pengaturan Pengguna',
      },
      Witnesses: {
        description:
          'Apakah Anda memberi tahu orang lain, atau apakah ada orang yang melihat apa yang terjadi?',
        header: 'Ada saksi?',
        placeholder: 'Mulai mengetik...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Kirim pesan',
        title: 'Manajer Kasus Pesan',
        translationHeader: 'Pelajari lebih lanjut tentang terjemahan otomatis',
      },
      ReportCard: {
        addEvidence: 'Tambahkan bukti',
        submissionModeVia: 'melalui {{submissionMode}}',
        viewEvidence: 'Lihat bukti',
      },
      ReportList: {
        yourReports: 'Laporan Anda',
      },
      ReportingActivate: {
        buttonText: 'Lanjutkan',
        description:
          'Jika organisasi Anda telah mendaftarkan Anda untuk sebuah akun, kami akan mengirimkan Anda email dengan instruksi untuk menyelesaikan pengaturan.',
        emailInput: 'Email',
        header: 'Masukkan email kerja Anda',
        successAccount:
          'Jika organisasi Anda telah mendaftarkan Anda untuk sebuah akun, kami akan mengirimkan Anda email dengan instruksi untuk menyelesaikan pengaturan.',
        successEmail:
          'Jika Anda tidak langsung melihatnya, harap tunggu beberapa menit dan segarkan kotak masuk email Anda.',
        successHeading: 'Terima kasih',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Tambahkan bukti ke laporan Anda',
        descriptionText:
          'Menambahkan file sebagai bukti dapat membantu mendukung efisiensi penyelesaian oleh manajer kasus Anda. Harap pertimbangkan isi file (termasuk metadata file) jika Anda ingin tetap anonim, dan menghormati hak individu lain dan hukum yang berlaku. Untuk info lebih lanjut, silakan lihat <a>artikel bantuan</a> ini.',
        emptyMessage: 'Tidak ada bukti tambahan yang diunggah',
      },
      ReportingChangePassword: {
        back: 'Kembali',
        description:
          'Buat kata sandi yang kuat untuk menjaga keamanan akun Anda. Mulailah mengetik untuk melihat pedoman di bawah ini.',
        errorToast: 'Tidak bisa membuat kata sandi, token tidak valid.',
        header: 'Ubah Kata Sandi',
        incorrectCurrentPassword:
          'Kata sandi saat ini salah. Silakan periksa dan coba lagi.',
        invalidToken: 'Token tidak valid',
        passwordUpdated: 'Kata sandi diperbarui',
        passwordUpdatedDescription:
          'Kata sandi Anda telah berhasil diperbarui. Terima kasih sudah melakukan langkah ini untuk menjaga data Anda tetap aman!',
        passwordUsedBefore: 'Penggunaan kembali kata sandi tidak diizinkan',
        passwordUsedBeforeDescription:
          'Untuk keamanan Anda, Anda tidak dapat menggunakan kembali enam kata sandi terakhir Anda. Harap pilih kata sandi baru yang unik untuk menjaga keamanan akun Anda dan coba lagi.',
        toastDescription:
          'Kata sandi Anda telah berhasil diperbarui. Terima kasih telah melakukan langkah ini untuk menjaga keamanan data Anda!',
        toastMessage: 'Kata sandi diperbarui',
        updatePasswordCTA: 'Perbarui kata sandi',
      },
      ReportingConnect: {
        cancelButton: 'Batalkan',
        connectButton: 'Terhubung',
        disclaimer:
          'Menghubungkan akun Slack Anda dengan akun Vault Anda memastikan koneksi yang aman dan pribadi. <br /><br />Dengan menghubungkan, Anda dapat melaporkan perilaku yang tidak pantas atau mengajukan pertanyaan langsung di dalam Slack. Anda selalu memiliki opsi untuk melaporkan secara anonim setelah terhubung. Privasi dan keamanan Anda adalah prioritas utama kami.',
        heading:
          'Vault Platform meminta izin untuk mengakses akun Slack {{organisationName}} Anda',
        listHeading: 'Apa yang bisa Vault lakukan?',
        permissionIdentity: {
          extraInfo:
            'Vault akan memiliki kemampuan untuk melihat identitas pengguna Slack Anda',
          heading: 'Lihat informasi tentang identitas pengguna',
        },
        permissionNotifications: {
          extraInfo:
            'Vault akan dapat mengirimkan notifikasi ke akun Slack Anda, mengenai setiap pembaruan pada laporan atau pertanyaan yang telah diajukan.',
          heading: 'Kirimkan anda pemberitahuan',
        },
        permissionOverview: {
          extraInfo:
            'Vault akan menampilkan ikhtisar semua submisi di halaman utama',
          heading: 'Ikhtisar pengajuan',
        },
        permissionSubmitReport: {
          extraInfo:
            'Ini akan memberikan izin kepada Vault untuk mengirimkan laporan atau bertanya langsung ke organisasi Anda, dari Slack',
          heading: 'Kirimkan laporan atau pertanyaan atas nama Anda',
        },
        successfulConnectionDescription:
          'Akun Vault dan akun Slack Anda sekarang sudah terhubung. Anda sekarang dapat menutup tab ini dan kembali ke Slack.',
        successfulConnectionHeading: 'Berhasil terhubung',
        unsuccessfulConnectionDescription:
          'Ada yang salah. Silakan tutup tab ini dan kembali ke Slack untuk mencoba lagi.',
        unsuccessfulConnectionHeading: 'Koneksi gagal',
      },
      ReportingForgotPassword: {
        description:
          'Masukkan alamat email yang terhubung dengan akun Anda, dan kami akan mengirimkan Anda tautan untuk mereset kata sandi Anda.',
        heading: 'Lupa kata sandi',
        invalidTokenError: 'Tidak bisa membuat kata sandi, token tidak valid.',
        passwordReuseError: 'Penggunaan ulang kata sandi tidak diizinkan',
        passwordReuseErrorDescription:
          'Untuk keamanan Anda, Anda tidak bisa menggunakan ulang enam password terakhir Anda. Silakan pilih password baru dan unik untuk menjaga keamanan akun Anda dan coba lagi.',
        sendLink: 'Kirim tautan reset',
        sendLinkFailure: 'Ada yang salah',
        sendLinkFailureDescription:
          'Kembali ke <a>Reporter Hub</a> dan coba lagi. Jika masalah terus berlanjut, hubungi kami di <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Tautan untuk mereset kata sandi telah dikirim',
        sendLinkSuccessDescription:
          'Kami telah mengirim tautan untuk mengatur ulang kata sandi ke {{email}}',
        updatePasswordSuccess: 'Kata sandi diperbarui',
        updatePasswordSuccessDescription:
          'Kata sandi Anda telah berhasil diperbarui. Terima kasih telah melakukan langkah ini untuk menjaga data Anda tetap aman!',
      },
      ReportingLogin: {
        accountFrozen: 'Akun dibekukan',
        accountLocked:
          'Login telah dicoba terlalu banyak kali secara salah. Akun ini dikunci hingga 1 jam. Tidak mungkin untuk mereset kata sandi selama waktu ini.',
        accountLockedPermanently:
          'Akun Anda telah dikunci. Gunakan reset kata sandi untuk mendapatkan kembali akses atau hubungi administrator sistem Anda untuk bantuan lebih lanjut.',
        createAccountCTA: 'Daftar untuk sebuah akun',
        currentPassword: 'Kata Sandi Saat Ini',
        emailLabel: 'Email Anda',
        forgotPassword: 'Lupa kata sandi Anda?',
        loginButton: 'Masuk',
        newPasswordPlaceholder: 'Kata sandi baru',
        passwordFailMessage:
          'Kembali ke Aplikasi Vault di Slack dan coba lagi. Jika masalah terus berlanjut, hubungi kami di techsupport@vaultplatform.com',
        passwordFailTitle: 'Ada yang salah',
        passwordLabel: 'Kata Sandi Anda',
        passwordPlaceholder: 'Masukkan kata sandi Anda',
        passwordResetRequired: 'Diperlukan reset kata sandi',
        passwordSuccessfullySetMessage:
          'Kembali ke Aplikasi Vault di Slack dan autentikasi dengan kata sandi baru Anda untuk melanjutkan dari mana Anda berhenti.',
        passwordSuccessfullySetTitle: 'Kata sandi berhasil diatur',
        reenterPlaceholder: 'Masukkan ulang kata sandi',
        title: 'Reporter Hub',
        tooltip:
          'Jika Anda belum pernah menetapkan kata sandi untuk aplikasi Vault, ikuti di sini untuk memulai. Jika Anda lupa kata sandi Anda, gunakan tautan "Lupa Kata Sandi" di bawah ini.',
        usernameLoginFailed: 'Login gagal, nama pengguna atau kata sandi salah',
      },
      ReportingReset: {
        failureDescription:
          'Kembali ke Aplikasi Vault di Slack dan coba lagi. Jika masalah berlanjut, hubungi kami di <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Ada yang salah',
        successDescription:
          'Kembali ke Aplikasi Vault di Slack dan otentikasi dengan kata sandi baru Anda untuk melanjutkan dari tempat Anda berhenti.',
        successHeading: 'Kata sandi berhasil diatur',
      },
      noReports: {
        description:
          'Semua laporan yang diserahkan akan ditampilkan di sini. Pelajari lebih lanjut tentang cara Anda dapat mengajukan laporan di',
        descriptionHelpArticle: 'artikel bantuan ini',
        errorDescription:
          'Kami mengalami kesulitan untuk memuat laporan Anda. Silakan coba segarkan halaman ini.',
        errorDescriptionSecondary:
          'Jika itu tidak berhasil, silakan hubungi kami di',
        errorTitle: '⚠️ Ups, ada yang salah',
        title: 'Anda belum memiliki laporan',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Aktifkan terjemahan otomatis dan baca semua pesan laporan dalam bahasa yang Anda pilih. Bahasa yang diterjemahkan berdasarkan bahasa yang dipilih pada perangkat Anda.',
          autoTranslationDescription2:
            'Anda dapat beralih antara bahasa terjemahan dan bahasa asli dalam setiap percakapan.',
          autoTranslationTitle:
            'Mengaktifkan otomatis terjemahan untuk pesan laporan',
          header: 'Pengaturan Pesan',
          subHeader: 'Atur bagaimana pesan ditampilkan',
        },
        notificationSettings: {
          emailDescription:
            'Terima notifikasi email untuk pembaruan penting pada laporan Anda',
          emailTitle: 'Notifikasi Email',
          header: 'Pengaturan Notifikasi',
          subHeader: 'Konfigurasikan cara Anda menerima notifikasi',
        },
        title: 'Pengaturan',
        updatedSettingsFailure: 'Gagal memperbarui pengaturan Anda',
        updatedSettingsSuccess: 'Berhasil memperbarui pengaturan Anda',
      },
    },
    validators: {
      passwordLength: 'Sandi harus memiliki panjang minimal 9 karakter',
      passwordLowercase: 'Sandi harus memiliki minimal 1 karakter huruf kecil',
      passwordMissMatch: 'Kolom sandi dan konfirmasi harus cocok.',
      passwordNumeric: 'Sandi harus memiliki minimal 1 angka',
      passwordUppercase: 'Sandi harus memiliki minimal 1 karakter huruf besar',
    },
    validatorsNew: {
      passwordLength: 'Antara 10 dan 30 karakter',
      passwordLowercase: 'Setidaknya satu huruf kecil',
      passwordMissMatch: 'Kata sandi tidak cocok',
      passwordNumeric: 'Setidaknya satu nomor',
      passwordSpecialCharacter: 'Setidaknya satu karakter khusus',
      passwordUppercase: 'Setidaknya satu huruf besar',
    },
  },
};

export default translations;
